import { Container } from 'react-bootstrap';


const Refund = () => {





  return (
    <Container className="terms-container" style={{ paddingTop: "140px" }}>
      <div className="terms-header">


        <div className="headingg">
          <h3 className="text-center">Return & Refund<span style={{ color: "#E53D5C" }}> Policy</span>  </h3>
        </div>
      </div>

      <div className="terms-content" >

        <div class="privacy-policy-container container">

          <div class="policy-content my-5 pb-5">
            <h4>Non-Refundable Money Policy for Hindu Sanjog:</h4>
            <p>At Hindu Sanjog we strive to provide the best possible services to our users. However, due to the nature of our business, we have a non-refundable payment policy in place.</p>

            <h4>Payment Terms:</h4>
            <p>All payments made to Hindu Sanjog are non-refundable.</p>
            <p>By making a payment, you acknowledge that you have read, understood, and agreed to this non-refundable policy.</p>

            <h4>Reasons for Non-Refundable Policy:</h4>
            <p>Our services are designed to provide users with access to a vast pool of potential matches, and payments are processed immediately upon registration or service purchase.</p>
            <p>We invest significant resources in maintaining our platform, ensuring user safety.</p>
            <p>Due to the digital nature of our services, we cannot cancel or reverse payments once they are processed.</p>

            <h4>User Responsibilities:</h4>
            <p>It is essential to carefully review our services, terms, and conditions before making a payment.</p>

            <h4>Contact Us:</h4>
            <p>If you have any questions or concerns about our non-refundable policy or payment terms, please contact us at <a href="mailto:support@hindusanjog.com">support@hindusanjog.com</a> or Phone number 8088010188.</p>

            <p>By using our services and making payments, you acknowledge that you have read, understood, and agreed to this non-refundable money policy.</p>

          </div>

        </div>
      </div>

    </Container>
  );
};

export default Refund;